module.exports = __webpack_public_path__ + "img/irisa-gray.d57bad4.png";